export default {
  /*管理员打款状态*/
  orderstatus:[
      {name:'未知',id:0},
      {name:'平台待打款',id:1},
      {name:'平台已打款',id:2}
  ],
  /*酒店查看订单状态*/
  HOrderStatus: [
    { id: 0, name: '待报价'},
    { id: 1, name: '已报价' },
    { id: 4, name: '待报价' },
    { id: 5, name: '待确认' },
    { id: 7, name: '待入住' },
    { id: 8, name: '已入住' },
    { id: 9, name: '完成' },
    { id: 97, name: '未被选中' },
    { id: 99, name: '取消' },
  ],
  /*采购商、管理员查看的订单状态*/
  TOrderStatus: [
    { id: 0, name: '默认' },
    { id: 1, name: '待审核' },
    { id: 2, name: '待匹配' },
    { id: 3, name: '待推送' },
    { id: 4, name: '询价中' },
    { id: 5, name: '待确认' },
    { id: 7, name: '待入住' },
    { id: 8, name: '已入住' },
    { id: 9, name: '完成' },
    { id: 99, name: '取消' },
  ],
  /*景区订单状态*/
  SOrderStatus: [
    {id: 21, name: '散客票待支付'},
    {id: 14, name: '待确认'},
    {id: 6, name: '团队票待设置金额'},
    {id: 8, name: '团队票待支付'},
    {id: 9, name: '已出票'},
    {id: 99, name: '已过期'},
    { id: 100, name: '已取消' },
  ],
  /*年卡订单状态*/
  YOrderStatus: [
    {id: 1, name: '待付款'},
    {id: 2, name: '已付款，待发货'},
    {id: 3, name: '已发货'},
  ],
  /*订单类型*/
  OrderStyle: [
    /*后台order_style字段*/
    { id: 3, name: '住宿订单' },
    { id: 5, name: '民宿订单' },
    { id: 6, name: '景区订单' },
    { id: 7, name: '度假产品订单' },
    { id: 8, name: '品牌馆订单' },
  ],
  /*订单细分类型*/
  OrderType: [
    /*后台order_type字段*/
    { id: 1, name: '住宿订单' },
    { id: 2, name: '纯会议订单' },
    { id: 3, name: '客房+会议室订单' },
    { id: 4, name: '景区散客票' },
    { id: 5, name: '景区团队票' },
    { id: 6, name: '度假常规产品' },
    { id: 7, name: '度假限购产品' },
    { id: 8, name: '品牌馆订单' },
  ],
  /*发布订单时的早餐类型*/
  breakfastArr: [
    { id: 1, name: '自助早'},
    { id: 2, name: '桌早'},
    { id: 3, name: '打包早'},
    { id: 4, name: '无早'},
  ],
  /*发布订单时的餐饮需求*/
  eateryArr: [
    { id: 1, name: '自助餐'},
    { id: 2, name: '活动宴会'},
    { id: 3, name: '会议简餐'},
    { id: 4, name: '团队桌餐'},
  ],
  /*用餐类型*/
  mealType: [
    { id: 0, name: '不需要用餐' },
    { id: 1, name: '自助餐' },
    { id: 2, name: '中式餐' },
  ],
  /*景点票种*/
  ticketTypeArr: [
    /*散客票种类*/
    {name: '特惠票', id: 1},
    {name: '成人票', id: 2},
    {name: '学生票', id: 3},
    {name: '亲子家庭票', id: 4},
    {name: '组合套票', id: 5},
    {name: '老年票', id: 6},
    /*设置团队订单金额时4种人群*/
    // {name: '成人', id: 6},
    // {name: '儿童', id: 7},
    // {name: '老人', id: 8},
    // {name: '特惠人群', id: 9},
  ],
  /*年卡状态*/
  yearCardStatus: [
    {name: '待付款', id: 1},
    {name: '已付款，待发货', id: 2},
    {name: '已发货', id: 3},
  ],
  /*景点门票类型*/
  ticketTopType: [
    {id: '1', name: '团队票'},
    {id: '2', name: '散客票'},
    //1-住宿订单  2-会议室订单  3-住宿+会议室订单 4-景区散客票 5-景区团队票
    {id: '4', name: '散客票'},
    {id: '5', name: '团队票'},
  ],
  /*景点团队门票类型*/
  groupTicketType: [
    {id: 1, name: '成人团'},
    {id: 2, name: '老年团'},
    {id: 3, name: '学生团'},
    {id: 4, name: '散拼团'},
    {id: 5, name: '亲子团'},
    {id: 6, name: '考察团'},
    {id: 7, name: '外宾团'},
  ],
  /*景区散客订单设置的取票方式*/
  ScenicCheckType:[
    {id:1,name:'身份证'},
    {id:2,name:'手机号'},
    {id:3,name:'校验码'},
  ],
  /*度假产品订单状态*/
  VocationStatusType:[
    {id:8,name:'待支付'},
    {id:9,name:'已完成'},
    {id:14,name:'待确认'},
    {id:99,name:'超时取消'},
    {id:100,name:'已取消'},
  ],
  /*酒店修改显示文字*/
  hotelTips:{
      name:'发起方修改，需向对方确认，待其同意后，修改才会生效。反之亦然。',
      text:'(发起方->修改->确认方->同意修改)',
      tips:'已向采购商发单人发送消息通知，待其确认后，修改的订单内容才会生效',
      notice:'通知采购商，待其同意后方可变更成功？',
      payment:'是否通知支付人确认？待其付款后，将自动确认修改订单？',

  },
  /*采购商修改显示文字*/
  travelTips:{
      name:'发起方修改，需向对方确认，待其同意后，修改才会生效。反之亦然。',
      text:'(发起方->修改->确认方->同意修改)',
      tips:'已向酒店报价人发送消息通知，待其确认后，修改的订单内容才会生效',
      notice:'通知酒店，待其同意后方可变更成功？'
  },
    //采购商取消文字
    travelReason:[
        {value:'团队未成行',id:'1'},
        {value:'团队选择其他酒店',id:'2'},
        {value:'信息填写错误',id:'3'},
        {value:'本人离职',id:'4'},
    ],
    //供应商取消文字
    hotelReason:[
        {value:'房间不足',id:'1'},
        {value:'信息填写错误',id:'2'},
        {value:'无会议档期',id:'4'},
        {value:'本人离职',id:'3'},
    ],
}
